import React from 'react';
import {QuietCard} from './quiet-card/quiet-card';
import {Articles} from '../../../../../models/experiencefragments/category-view';
import {SecondaryButton} from '../../../../../components/common';
import './category-popular-articles-trio.scss';

interface CategoryPopularArticlesTrioProps {
    articles: Articles;
    dictionaryOrResourcesAnalyticsText?: string;
}

export const CategoryPopularArticlesTrio = (props: CategoryPopularArticlesTrioProps ) => {
    return (
        <article className="category-quiet-cards-trio">
            <div className="category-quiet-cards-heading">
                <h2 className="category-quiet-cards-trio__title">
                    {props.articles.sectionHeading}
                </h2>
                {props.articles.cta?.title && props.articles.cta?.url && (
                    <SecondaryButton
                        linkTarget={props.articles.cta?.targetBlank ? '_blank' : ''}
                        link={props.articles.cta?.url}
                        noChevron={false}
                        aria-label={props.articles.cta?.ariaLabel}
                        dataTestId="explore-all-link"
                    >
                        {props.articles.cta?.title}
                    </SecondaryButton>
                )}

                <div className="category-quiet-cards-trio__subcopy">
                    {props.articles.sectionSubCopy}
                </div>
            </div>
            <hr className="category-quiet-cards-trio__divider"/>
            <section className="category-quiet-cards">
                {(props.articles.articles || []).map((article, index) => {
                    return (
                        <QuietCard
                            key={index}
                            article={article}
                            dictionaryOrResourcesAnalyticsText={props.dictionaryOrResourcesAnalyticsText}
                            clickedCardText={article.ctaLabel || ''}
                        />
                    );
                })}
            </section>
        </article>
    );
};
